/**
 * 🔒 ROLE HELPER - Helper para acessar role do usuário
 *
 * Utilitário para acessar role do usuário de forma confiável
 * em filtros Vue.js e outros contextos sem acesso direto ao componente
 *
 * @module roleHelper
 */

/**
 * 🔍 Obter role do usuário atual
 *
 * @returns {string} Role do usuário ('attendant', 'supervisor', etc.)
 */
export function getUserRole() {
  try {
    // Tentar 1: window.store (mais confiável em filtros)
    if (typeof window !== 'undefined' && window.store) {
      const role = window.store.getters?.profile || window.store.state?.user?.profile || ''
      if (role) {
        console.log('🔒 [roleHelper] Role obtido de window.store:', role)
        return role
      }
    }

    // Tentar 2: Vue.prototype.$store
    if (typeof Vue !== 'undefined' && Vue.prototype && Vue.prototype.$store) {
      const role = Vue.prototype.$store.getters?.profile || Vue.prototype.$store.state?.user?.profile || ''
      if (role) {
        console.log('🔒 [roleHelper] Role obtido de Vue.prototype.$store:', role)
        return role
      }
    }

    // Tentar 3: localStorage (fallback mais confiável)
    if (typeof localStorage !== 'undefined') {
      // Tentar user_data primeiro
      const userData = localStorage.getItem('user_data')
      if (userData) {
        try {
          const user = JSON.parse(userData)
          const role = user.role || user.profile || ''
          if (role) {
            console.log('🔒 [roleHelper] Role obtido de localStorage (user_data):', role)
            return role
          }
        } catch (e) {
          // Ignorar erro de parse
        }
      }

      // Tentar auth_token (pode ter informações do usuário no JWT)
      const authToken = localStorage.getItem('auth_token')
      if (authToken) {
        try {
          // Decodificar JWT sem validação (apenas para obter role)
          const payload = JSON.parse(atob(authToken.split('.')[1]))
          const role = payload.role || payload.profile || ''
          if (role) {
            console.log('🔒 [roleHelper] Role obtido de JWT token:', role)
            return role
          }
        } catch (e) {
          // Ignorar erro de decode
        }
      }
    }

    console.warn('⚠️ [roleHelper] Role não encontrado em nenhuma fonte')
    return ''
  } catch (error) {
    console.warn('⚠️ [roleHelper] Erro ao obter role do usuário:', error)
    return ''
  }
}

/**
 * 🔒 Verificar se deve ofuscar dados
 *
 * @param {boolean} forceMask - Forçar ofuscação mesmo se role permitir
 * @returns {boolean} true se deve ofuscar
 */
export function shouldMaskData(forceMask = false) {
  if (forceMask) return true

  const role = getUserRole()
  return role === 'attendant'
}
